export const SALES_ECONOMICS_ACTIVITY_CONCURRENCY = 4;

export function normalizeSalesEconomicsProviderData(
  providerData: unknown,
): string {
  return typeof providerData === "string"
    ? providerData
    : JSON.stringify(providerData ?? {});
}

export const SALES_ECONOMICS_DEAL_COLUMNS = `
  id, company_id, created_at, closed_at, is_closed, is_won, is_lost,
  name, pipeline, provider, provider_id, provider_owner_id, updated_at,
  value, currency_id, currency_code, deal_type, provider_data, users
`;
